module.exports = __webpack_public_path__ + "media/images/pic/certificates/gazele-2011-100a750c50ff9e5ab7bf9fb69d644cfc.png";